var _path, _path2, _line, _g, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGolf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    stroke: "currentColor",
    strokeWidth: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.2,773.3L849.5,94c4.3-7,13.4-9.2,20.4-4.8l27.8,17.5c7,4.4,9,13.6,4.5,20.5L464,796.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M416.7,761.7l63.4,45l-42.1,51.6c-8.1,10-18.9,17.4-31.1,21.4l-164.2,54.5c-9.6,3.2-19.9,3.6-29.7,1.1 c-26.9-6.8-77.9-27.1-90.5-85.3c-7.3-33.6-1.3-58.2,8.3-75.6c12.5-22.7,39.5-33,63.9-24.6l182,62.7L416.7,761.7z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 706.2,
    y1: 339.6,
    x2: 742,
    y2: 362.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M863.2,743.4c0,55.2-44.7,99.9-99.9,99.9c-55.2,0-99.9-44.7-99.9-99.9c0-55.2,44.7-99.9,99.9-99.9 C818.4,643.6,863.2,688.3,863.2,743.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 741.7,
    y1: 786.8,
    x2: 741.7,
    y2: 786.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 774.2,
    y1: 754.3,
    x2: 790.4,
    y2: 738.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 806.7,
    y1: 721.8,
    x2: 806.7,
    y2: 721.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 783.5,
    y1: 796.9,
    x2: 783.5,
    y2: 796.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 816.7,
    y1: 763.7,
    x2: 816.7,
    y2: 763.7
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M716.7,850.5l10.2,4.3c22.2,9.4,36.7,31.2,36.7,55.4V937"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M809.9,850.5l-10.2,4.3c-22.2,9.4-36.7,31.2-36.7,55.4V937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf);
export default __webpack_public_path__ + "static/media/Golf.c65d50e9d49697a3f23d5477e3e44936.svg";
export { ForwardRef as ReactComponent };